'use strict';

module.exports = ['Video', 'Teaser', 'Full'];
// This file contains the video titles for the venue used in the application.